module.exports = __webpack_public_path__ + "img/CS-Lite-Plus_Overview-Front_1.aef6e854.jpg";